export const SIZES = {
  mobile: '480px',
  tablet: '768px',
  small: '1024px',
  drawer: '1125px',
  large: '1200px',
};
